import axios from "axios";
import React from "react";
import { DATA_SHEET_URL, THEMES_SHEET_URL, CHILDREN_SHEET_URL, TOPICS_SHEET_URL } from "../config/constants";

const useScienceData = () => {
    const [opportunitiesData, setOpportunitiesData] = React.useState(null);
    const [themesData, setThemesData] = React.useState(null);
    const [childrenData, setChildrenData] = React.useState(null);
    const [topicsData, setTopicsData] = React.useState(null);

    React.useEffect(() => {
        Promise.all([
            axios(DATA_SHEET_URL)
                .then(res => res.data)
                .then(setOpportunitiesData),

            axios(THEMES_SHEET_URL)
                .then(res => res.data)
                .then(setThemesData),

            axios(CHILDREN_SHEET_URL)
                .then(res => res.data)
                .then(setChildrenData),

            axios(TOPICS_SHEET_URL)
                .then(res => res.data)
                .then(setTopicsData),
        ]);
    }, []);

    return {
        opportunitiesData,
        themesData,
        childrenData,
        topicsData,
    };
};

export default useScienceData;
